import { appContext } from "../../../../AppContext";
import { RouterProps } from "react-router";
import Booking from "./homeBookings.png";
import Catering from "./homeCatering.png";
import Visitors from "./homeVisitor.png";
import Space from "./homeBookSpace.png";
import { Box, Grid } from "@mui/material";
import {Typography} from "@mui/material";
import { IUserRights } from "../../../../Providers.Api/Models.UserApi";
import IbssHomeCard from "../../../../Components/Cards/HomePageCard/IbssHomeCard";
import { IbssPage } from "../../../../Components/Core/BasePage/IbssPage";
import { SearchSpacesHelper } from "../../../Shared/Spaces/Search/SearchSpacesHelper";
import { rights } from "../../../../Common/RightsManager";
import IbssPageHeader from "../../../../Components/Headings/PageHeading/IbssPageHeader";

class OnelensHome extends IbssPage<IProps, IState>
{
    private get appState() { return appContext().state; }
    private get local() { return appContext().localStorageProvider; }
    private get session() { return appContext().sessionStorageProvider; } 
    private get labels() { return appContext().labels; }

    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
            buildingId: this.appState.buildingId,           
        }
    }

    public componentDidMount(): void
    {
        this.pageTitle = this.labels.HubMenuHome;
        this.appState.autoMap(this, i => ({ buildingId: i.buildingId }));
    }

    public render(): JSX.Element
    {
        const displayName = this.local.getUserDetails().displayName;
        const buildingName = this.appState.buildingName;

        const callToActions: ICallToAction[] = [
            {
                id: '1',
                title: this.labels.funcBookingHomeSpace_S,
                description: this.labels.funcBookingHomeSpace_L,
                src: Space,
                imageAlt: this.labels.funcBookingHomeSpace_S,
                route: `/one-lens/spaces/search?${SearchSpacesHelper.buildQuery(this.state.buildingId)}`,
                permissions: rights.FLEX.Search.Spaces.has(),
            },
            {
                id: '2',
                title: this.labels.OneLens_Visitors_MenuItem,
                description: this.labels.funcVisitorsHomeView_L,
                src: Visitors,
                imageAlt: this.labels.OneLens_Visitors_MenuItem,
                route:`/operational-services-visitors/${this.state.buildingId}`,
                permissions: rights.ONELENS360.OperationalServices.Visitors.has(),
            },
            {
                id: '3',
                title: this.labels.HubLabelBookings,
                description: this.labels.funcBookingHomeView_L,
                src: Booking,
                imageAlt: this.labels.HubLabelBookings,
                route:`/operational-services-bookings/${this.state.buildingId}/0`,
                permissions: rights.ONELENS360.OperationalServices.Bookings.has(),
            },
            {
                id: '4',
                title: this.labels.HubLabelCateringTable,
                description: this.labels.funcCateringOrdersHomeView_L,
                src: Catering,
                imageAlt: this.labels.HubLabelCateringTable,
                route:`/catering-orders/${this.state.buildingId}`,
                permissions: rights.ONELENS360.OperationalServices.Catering.has(),
            },
            
        ]

        return (
            <div className="rightPanel-main-content">
                <Box 
                    sx={theme => 
                        ({
                            [theme.breakpoints.up(1800)]: { // media query for screen sizes above 1800 pixels width
                                mt: 4,
                                mb: 4,
                            },
                            [theme.breakpoints.down(1800)]: {
                                mt: 0,
                                mb: 2,
                            },
                        })
                    }
                >
                    <IbssPageHeader
                        title={`${this.labels.funcWelcomeToHomeLabel_S} ${buildingName}, ${displayName}`}
                    />
                </Box>
                <Box sx={{width:'100%', overflow: 'auto'}}>
                    <Grid container  spacing={3}>     
                    {callToActions.filter(i => i.permissions === true).map((item) => 
                        <Grid 
                            item 
                            md={6}
                            key={item.id}
                        >
                            <IbssHomeCard           
                                title={item.title}
                                description={item.description}
                                src={item.src}
                                imageAlt={item.imageAlt}
                                route={item.route}
                                redirect={() => this.props.history.push(item.route)}
                            />
                        </Grid>
                    )}
                    </Grid>
                </Box>
            </div>
        );
    }
}

interface IProps extends RouterProps
{
}

interface IState
{
    buildingId: number;
}

export interface ICallToAction
{
    id: string;
    title: string;
    description: string;
    src: string;
    imageAlt: string;
    route: string;
    permissions: boolean;
}

export default OnelensHome;
